import Modal from '../Modal';
import Product from './Product';

import { cartApi, showQuickshop, updateCart } from '../../helpers';

const selectors = {
  quickShopTrigger: '[data-quickshop-trigger]',
  modalContent: '[data-dialog-content]',
  modalProduct: '[data-product]',
  addToCartButton: '[data-add-to-cart]',
};

/**
 * A single product item in a collection / list of products
 *
 * @export
 * @class ProductItem
 */
export default class ProductItem {
  /**
   * Creates an instance of ProductItem.
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.el = el;
    this.modalContent = document.querySelector(selectors.modalContent);

    const addToCartButtons = this.el.querySelectorAll(
      selectors.addToCartButton,
    );
    if (addToCartButtons.length > 0) {
      addToCartButtons.forEach(button => {
        button.addEventListener('click', e => {
          this._addToCart(e.target.dataset.addToCart);
        });
      });
    }

    this._initQuickShop();
  }

  _initModal() {
    this.modal = new Modal();
  }

  _onModalOpen = quickShopUrl => {
    const product = this.modalContent.querySelector(selectors.modalProduct);

    // Create a new Product instance for the requested quickshop product
    new Product(product, {
      isQuickShop: true,
      quickShopUrl: quickShopUrl,
      modal: this.modal,
    });
  };

  /**
   * Bind quickshop to a trigger
   */
  _initQuickShop() {
    const trigger = this.el.querySelector(selectors.quickShopTrigger);

    if (!trigger) {
      return;
    }

    trigger.addEventListener('click', () => {
      const { productUrl } = this.el.dataset;

      const quickshopUrl = `${productUrl}?section_id=${window.quickshopSectionId}`;

      fetch(quickshopUrl)
        .then(response => response.text())
        .then(data => {
          this._initModal();

          const quickshopHtml = showQuickshop(data);

          this.modal.open(quickshopHtml);
          this._onModalOpen(quickshopUrl);
        });
    });
  }

  /**
   * This function is called whenever the user submits the form
   *
   * @param {*} event
   */
  _addToCart = id => {
    cartApi
      .add({
        items: [
          {
            id,
            quantity: 1,
          },
        ],
      })
      .then(response => {
        if (response.sections) {
          updateCart({ sections: response.sections, openCart: true });
        }
      })
      .catch(error => {
        console.error(error);
      });
  };
}
